import type { Subscription } from '../types';
import { PlanTypes } from '../types';

import { isModernSubscription } from './isModernSubscription';

/**
 * True when the subscription is on the free developer plan (Developer2025).
 * Use for billing UI that should treat these like "no paid plan" (e.g. default to monthly, show interval selector).
 */
export function hasFreeDevPlan(subscription: Subscription | null | undefined): boolean {
  return !!(subscription && isModernSubscription(subscription) && subscription.planType === PlanTypes.DEVELOPER2025);
}
